import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import localForage from "localforage";
import { Elements } from "react-stripe-elements";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Moment from "moment";
import CartProduct from "./CartProduct";
import CheckoutForm from "./CheckoutForm";

@inject("CartStore", "UserStore")
@observer
class Cart extends Component {
	constructor(props) {
		super(props);

		this.state = {
			openedForm: false,
			cartDates: []
		};
	}

	async componentDidMount() {
		const items = await localForage.getItem("cart");
		const cartDates = await localForage.getItem("cartDates");

		if (items) {
			const updatedItems = items.map((item, key) => {
				const cartDate = cartDates ? cartDates[key] : null;
				if (cartDate) {
					const startDateMoment = Moment(cartDate.startDate);
					const endDateMoment = Moment(cartDate.endDate);
					const days = endDateMoment.diff(startDateMoment, "days");
					console.log("Loaded days:", days);
					return {
						...item,
						days
					};
				}

				return item;
			});
			this.setState(
				{
					cartDates: updatedItems.map((item, key) => {
						return {
							product: item,
							...(cartDates && cartDates[key]
								? cartDates[key]
								: { startDate: Moment(), endDate: Moment(), locked: true })
						};
					})
				},
				() => {
					this.props.CartStore.setCart(updatedItems);
				}
			);
		}
	}

	modifyLockedDates = (startDate, endDate) => {
		const { cartDates } = this.state;
		const { CartStore } = this.props;

		const newCartDates = cartDates.map(cartDate => {
			if (cartDate.locked) {
				const startDateMoment = Moment(startDate);
				const endDateMoment = Moment(endDate);
				const days = endDateMoment.diff(startDateMoment, "days");
				return {
					...cartDate,
					startDate: Moment(startDate).toISOString(),
					endDate: Moment(endDate).toISOString(),
					product: {
						...cartDate.product,
						days
					}
				};
			}

			return cartDate;
		});

		localForage.setItem("cartDates", newCartDates);

		this.setState({
			cartDates: newCartDates
		});

		CartStore.setCart(newCartDates.map(cartDate => cartDate.product));
	};

	updateCartDate = key => (newData = {}, newProductData = {}) =>
		new Promise((resolve, reject) => {
			const { cartDates } = this.state;

			const newCartDates = cartDates.map((cartDate, cartDateKey) => {
				if (key === cartDateKey) {
					return {
						...cartDate,
						...newData,
						product: {
							...cartDate.product,
							...newProductData
						}
					};
				}

				return cartDate;
			});

			localForage.setItem("cartDates", newCartDates);
			this.setState(
				{
					cartDates: newCartDates
				},
				() => {
					console.log("Saving cartDates", newCartDates);
					resolve(true);
				}
			);
		});

	removeCartDate = key => () =>
		new Promise((resolve, reject) => {
			const { cartDates } = this.state;

			const newCartDates = cartDates
				.map((cartDate, cartDateKey) => {
					if (key === cartDateKey) {
						return null;
					}

					return cartDate;
				})
				.filter(cartDate => !!cartDate);

			localForage.setItem("cartDates", newCartDates);

			this.setState(
				{
					cartDates: newCartDates
				},
				() => {
					// console.log("Saving cartDates", newCartDates);
					resolve(true);
				}
			);
		});

	getTotalInCart() {
		return this.props.CartStore.items
			.reduce(
				(total, item) =>
					total +
					((parseInt(item.days, 10) === 1
						? item.pricePerDay
						: parseInt(item.days, 10) === 2
						? item.pricePerDay * 1.7
						: parseInt(item.days, 10) === 3
						? item.pricePerDay * 1.95
						: parseInt(item.days, 10) >= 4 && parseInt(item.days, 10) <= 7
						? item.pricePerDay * 2.95
						: item.pricePerDay * 2.95 +
						  (parseInt(item.days, 10) - 7) * item.pricePerDay * 0.42) +
						(item.selectedWaiver ? item.price * 0.05 : 0)) *
						item.qty,
				0
			)
			.toFixed(2);
	}

	toggleCheckout() {
		this.setState({
			openedForm: !this.state.openedForm
		});
	}

	render() {
		return (
			<div className="main-content">
				<div className="section-title standalone">
					<p>
						YOUR CART{" "}
						<Link to="/Shop">
							<button className="back-shop">
								<i className="fa fa-angle-left"></i> Rent more equipment
							</button>
						</Link>
					</p>
					<div className="sep" />
				</div>

				<div className="table-view">
					<div className="table-head">
						<p>NAME</p>
						<p>DAMAGE WAIVER</p>
						<p>START DATE</p>
						<p>END DATE</p>
						<p>QTY</p>
						<p>PRICE</p>
					</div>
					<div className="table-entries">
						{this.props.CartStore.items.length > 0 &&
						this.state.cartDates.length > 0 ? (
							this.props.CartStore.items
								.filter((item, key) => item && this.state.cartDates[key])
								.map((item, key) => {
									const datePicker = this.state.cartDates[key];
									return (
										<CartProduct
											cartDate={datePicker}
											modifyLockedDates={this.modifyLockedDates}
											removeCartDate={this.removeCartDate(key)}
											updateCartDate={this.updateCartDate(key)}
											item={item}
											productKey={key}
											key={item._id}
										/>
									);
								})
						) : (
							<p className="no-items-text">No items were found in your cart</p>
						)}
					</div>
					<div className="tot-bar">
						<p>TOTAL: ${this.getTotalInCart()}</p>
					</div>
					<div className="check-btns">
						<span></span>
						{this.props.UserStore.user._id ? (
							<button onClick={this.toggleCheckout.bind(this)}>
								CHECK OUT
							</button>
						) : (
							<Link to="/register">
								<button>CHECK OUT</button>
							</Link>
						)}
					</div>
				</div>
				<div
					className={
						"formModalOverlay " + (this.state.openedForm ? "visible" : "")
					}
					onClick={this.toggleCheckout.bind(this)}
				/>
				<Elements>
					<CheckoutForm
						isOpen={this.state.openedForm}
						cartPrice={this.getTotalInCart()}
						toggleModal={this.toggleCheckout.bind(this)}
					/>
				</Elements>
				<ReactTooltip multiline={true} effect="solid" />
			</div>
		);
	}
}

export default Cart;



// WEBPACK FOOTER //
// ./src/components/Cart.js